/*
 * Dominick Horsewear - kolommenmenu in het desktop mega-menu (Equilin).
 * Hover op desktop, tik-om-te-openen op touch.
 * Terugdraaien? Zet in snippets/mega-menu.liquid de render van 'mega-menu-list' terug.
 */
(function () {
  if (window.__dominickMegaMenuColumns) return;
  window.__dominickMegaMenuColumns = true;

  var TRIGGER = '[data-cmm-open]';

  function isTouch() {
    return window.matchMedia('(hover: none), (pointer: coarse)').matches;
  }

  function menuRoot(el) {
    return el.closest('[data-cmm]');
  }

  function deactivate(root) {
    if (!root) return;
    var actives = root.querySelectorAll('.is-active');
    for (var i = 0; i < actives.length; i++) {
      actives[i].classList.remove('is-active');
      if (actives[i].hasAttribute('aria-expanded')) {
        actives[i].setAttribute('aria-expanded', 'false');
      }
    }
  }

  function activate(trigger) {
    var root = menuRoot(trigger);
    if (!root) return;
    var key = trigger.getAttribute('data-cmm-open');
    var panel = root.querySelector('[data-cmm-panel="' + key + '"]');
    deactivate(root);
    trigger.classList.add('is-active');
    trigger.setAttribute('aria-expanded', 'true');
    if (panel) panel.classList.add('is-active');
  }

  document.addEventListener(
    'mouseover',
    function (event) {
      if (isTouch()) return;
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      var trigger = target.closest(TRIGGER);
      if (trigger) activate(trigger);
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      if (!isTouch()) return;
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      var trigger = target.closest(TRIGGER);
      if (!trigger) return;

      // Eerste tik opent de kolom, tweede tik volgt de link.
      if (trigger.getAttribute('aria-expanded') !== 'true') {
        event.preventDefault();
        activate(trigger);
      }
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      var trigger = target.closest(TRIGGER);
      if (trigger) activate(trigger);
    },
    true
  );

  // Alles dichtklappen zodra de bezoeker het menu verlaat.
  document.addEventListener(
    'pointerleave',
    function (event) {
      var target = event.target;
      if (!target || typeof target.matches !== 'function') return;
      if (!target.matches('.menu-list__list-item, .menu-list__submenu, [data-cmm]')) return;
      deactivate(target.querySelector('[data-cmm]') || menuRoot(target) || target);
    },
    true
  );
})();
